import { format, isValid, parseISO } from 'date-fns';

/**
 * Ordinal date + 24h time for customer-facing UI copy (e.g. cancellation confirmation).
 * Not for API payloads — use ISO strings on requests, not these display values.
 */
export type OrdinalDisplayDateTime = Readonly<{
	date: string;
	time: string;
}>;

const toOrdinalDisplayDateTime = (parsed: Date): OrdinalDisplayDateTime => ({
	date: format(parsed, 'do MMMM yyyy'),
	time: format(parsed, 'HH:mm'),
});

/** Formats an ISO string as ordinal date (`do MMMM yyyy`) and 24h time (`HH:mm`). */
export const formatIsoToOrdinalDateAndTime = (isoDate: string): OrdinalDisplayDateTime => {
	const parsed = parseISO(isoDate);
	return toOrdinalDisplayDateTime(parsed);
};

/** Returns formatted date/time when present and parseable, otherwise `null`. */
export const formatIsoToOrdinalDateAndTimeOrNull = (isoDate?: string | null): OrdinalDisplayDateTime | null => {
	const trimmed = isoDate?.trim();
	if (!trimmed) {
		return null;
	}

	const parsed = parseISO(trimmed);
	if (!isValid(parsed)) {
		return null;
	}

	return toOrdinalDisplayDateTime(parsed);
};
